module.exports = __webpack_public_path__ + "img/3d-export_cn.42cba76.jpg";